// NOTE local Url
// export const baseUrl = "http://localhost:3000/api";
// NOTE develop Url
// export const baseUrl = "https://vulcan.houseofdev.tech/cmacc-dev/api";
// NOTE staging Url
// export const baseUrl = "https://vulcan.houseofdev.tech/cmacc/api";

// NOTE local Url
// export const baseUrl = "http://localhost:3000/api";
// NOTE develop Url
// export const baseUrl = "https://cmacc.in.th/api-dev/api";
// NOTE staging Url
export const baseUrl = "https://cmacc.in.th/api-uat/api";

export default baseUrl;
